export default {
  GET_NEWSLETTER(state, payload) {
    state.newsLetter = payload;
  },
};
